export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.newpageTags = payload;

  return newState;
};
